import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createCertificate } from "../../store/certificates/actions";
export var useApiCreateCertificate = function (trigger, certificateBody) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        loadingCreateCertificate: state.Certificates.loadingCreateCertificate,
        responseCreateCertificate: state.Certificates.responseCreateCertificate,
        errorCreateCertificate: state.Certificates.errorCreateCertificate,
    }); }), loadingCreateCertificate = _a.loadingCreateCertificate, responseCreateCertificate = _a.responseCreateCertificate, errorCreateCertificate = _a.errorCreateCertificate;
    useEffect(function () {
        if (trigger) {
            dispatch(createCertificate(certificateBody));
        }
    }, [trigger]);
    return {
        loadingCreateCertificate: loadingCreateCertificate,
        responseCreateCertificate: responseCreateCertificate,
        errorCreateCertificate: errorCreateCertificate,
    };
};
